import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'classesStudents.addClassModal.title',
    defaultMessage: 'ADD CLASS',
  },
  subtitle: {
    id: 'classesStudents.addClassModal.subtitle',
    defaultMessage: 'To add a class, you must:',
  },
  firstSection: {
    id: 'classesStudents.addClassModal.firstSection',
    defaultMessage:
      '1. Download the template available below, fill out the excel document and upload this file, so that registration is automatic.',
  },
  registrationInfo: {
    id: 'classesStudents.addClassModal.registrationInfo',
    defaultMessage:
      '2. In the "Registration" field, special characters will not be accepted, only letters and numbers.',
  },
  secondSection: {
    id: 'classesStudents.addClassModal.secondSection',
    defaultMessage: 'If you already have the completed file:',
  },
  downloadButton: {
    id: 'classesStudents.addClassModal.downloadButton',
    defaultMessage: 'DOWNLOAD TEMPLATE LIST V2',
  },
  dragDrop: {
    id: 'classesStudents.addClassModal.dragDrop',
    defaultMessage: 'Drag and drop file to upload',
  },
  clickHere: {
    id: 'classesStudents.addClassModal.clickHere',
    defaultMessage: 'or click here',
  },
  back: {
    id: 'classesStudents.addClassModal.back',
    defaultMessage: 'Back',
  },
  continue: {
    id: 'classesStudents.addClassModal.continue',
    defaultMessage: 'Continue',
  },
  manual: {
    id: 'classesStudents.addClassModal.manual',
    defaultMessage: 'Register manually',
  },
  line: {
    id: 'classesStudents.addClassModal.line',
    defaultMessage: 'Line',
  },
  column: {
    id: 'classesStudents.addClassModal.column',
    defaultMessage: 'Column',
  },
  selectSchool: {
    id: 'classesStudents.addClassModal.selectSchool',
    defaultMessage: 'Select school',
  },
  errorFeedbackMessage: {
    id: 'classesStudents.addClassModal.errorFeedbackMessage',
    defaultMessage:
      'It was not possible to add the class, please check the following errors in the spreadsheet processing:',
  },
  errorFeedbackInstructions: {
    id: 'classesStudents.addClassModal.errorFeedbackInstructions',
    defaultMessage: 'Please review the contents of the selected spreadsheet and try again',
  },
  errorType1: {
    id: 'classesStudents.addClassModal.errorType1',
    defaultMessage: 'The field cannot be empty',
  },
  errorType2: {
    id: 'classesStudents.addClassModal.errorType2',
    defaultMessage: 'Segment or level not found',
  },
  errorType3: {
    id: 'classesStudents.addClassModal.errorType3',
    defaultMessage: 'Invalid period for this course',
  },
  errorType4: {
    id: 'classesStudents.addClassModal.errorType4',
    defaultMessage: 'E-mail is not valid',
  },
  errorType5: {
    id: 'classesStudents.addClassModal.errorType5',
    defaultMessage: 'This email is already registered by another non-student user',
  },
  feedbackTitle: {
    id: 'classesStudents.addClassModal.feedbackTitle',
    defaultMessage: 'LOADED LIST',
  },
  feedbackErrorTitle: {
    id: 'classesStudents.addClassModal.feedbackErrorTitle',
    defaultMessage: 'ERROR ON LOADING LIST',
  },
  feedbackMessage: {
    id: 'classesStudents.addClassModal.feedbackMessage',
    defaultMessage: 'The file "{file}" was uploaded successfully',
  },
  updatedMonth: {
    id: 'classesStudents.addClassModal.updatedMonth',
    defaultMessage: 'updated in July/20',
  },
  warning: {
    id: 'classesStudents.addClassModal.warning',
    defaultMessage: 'Warning',
  },
  commonErrors1: {
    id: 'classesStudents.addClassModal.commonErrors1',
    defaultMessage: 'Empty file, please fill in the blanks needed.',
  },
  commonErrors2: {
    id: 'classesStudents.addClassModal.commonErrors2',
    defaultMessage: 'This user has no permission for this idCSchool.',
  },
  commonErrors3: {
    id: 'classesStudents.addClassModal.commonErrors3',
    defaultMessage: 'File type not supported. Only .xls or .xlsx files can be uploaded.',
  },
});
